/**
 * DOMExceptions like "Failed to execute 'removeChild' on 'Node'" often come from
 * third-party scripts, browser extensions, or portal teardown races — not always app bugs.
 */
export function isLikelyBenignRemoveChildError(error: unknown): boolean {
  if (error == null) return false;

  if (error instanceof DOMException) {
    if (error.name === "NotFoundError" || error.code === 8) {
      const msg = error.message ?? "";
      if (/removeChild/i.test(msg) && /not a child/i.test(msg)) return true;
      if (/remove/i.test(msg) && /child/i.test(msg)) return true;
    }
  }

  const message = error instanceof Error ? error.message : String(error);
  if (/Failed to execute 'removeChild' on 'Node'/i.test(message)) return true;
  if (/removeChild/i.test(message) && /not a child/i.test(message)) return true;

  return false;
}
